// Calcula el ritmo en segundos por cada 100 metros
export const calculateSwimmingPaceInSeconds = (distanceMeters, durationSeconds) => {
  if (!distanceMeters || !durationSeconds || distanceMeters === 0) return null;
  return (durationSeconds / distanceMeters) * 100;
};

// Ya existente
export const calculateSwimmingPace = (distanceMeters, durationSeconds) => {
  const secondsPer100m = calculateSwimmingPaceInSeconds(distanceMeters, durationSeconds);
  if (secondsPer100m === null) return null;

  const minutes = Math.floor(secondsPer100m / 60);
  const seconds = Math.round(secondsPer100m % 60);
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds} /100m`;
};

// Formatea segundos por 100 metros en formato mm:ss /100m
export const formatPace = (secondsPer100m) => {
  if (secondsPer100m == null || isNaN(secondsPer100m)) return null;
  const minutes = Math.floor(secondsPer100m / 60);
  const seconds = Math.round(secondsPer100m % 60);
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds} /100m`;
};
